var main = (function($) {

    function init() {

        // Unselect checkboxes except current
        $('.accordion input[type="checkbox"]').on('change', function() {
          $('.accordion input[type="checkbox"]').not(this).prop( "checked", false );
        });

        // disable form submit on enter key press in text fields, instead focus next field
        $('input[type=text]').keypress(function(e){
            if ( e.which == 13 ) {
                var index = $('input').index(this) + 1;
                $('input').eq(index).focus();
                e.preventDefault();
            }
        });

        // Show hide filters
        $('p.filters span').click(function(){
          $(this).parent().toggleClass('open');
          //$('div.filters_wrapper').slideToggle('open');
          if($("div.filters_wrapper").is(":hidden")){
            $("div.filters_wrapper").slideDown("fast");

            gtag('event', 'click', {
              'event_category': 'Tuotefiltterinappi',
              'event_label': 'avattu',
              'value': 1
            });

          } else {
            $("div.filters_wrapper").hide();

            gtag('event', 'click', {
              'event_category': 'Tuotefiltterinappi',
              'event_label': 'suljettu',
              'value': 1
            });

          }

          if( $(this).text() == 'Avaa tuotesuodatin' || $(this).text() == 'Sulje suodatin' ) {

            $(this).html() == 'Avaa tuotesuodatin' ? $(this).html('Sulje suodatin') : $(this).html('Avaa tuotesuodatin');
            // Since the product list is updated on every filter click we can change the submit button text (and functionality below).
            $( 'form#filters button[type="submit"]' ).text( 'Sulje suodatin' );

          } else {

            $(this).html() == 'Filter products' ? $(this).html('Hide filter options') : $(this).html('Filter products')
            // Since the product list is updated on every filter click we can change the submit button text (and functionality below).
            $( 'form#filters button[type="submit"]' ).text( 'Hide filter options' );

          }

        });

        // Since the product list is updated on every filter click we can change the submit button functionality (and text above).
        $( 'form#filters button[type="submit"]' ).click(function(e){

          $( 'p.filters span' ).click();

          $('html, body').animate({
            scrollTop: $('#breadcrumbs').offset().top
          },500);

          e.preventDefault();

        });

        // Filter reset button
        $('form#filters button[type="reset"]').click(function(){

          $( 'form#filters input[type="checkbox"]' ).each(function( index ) {

            $(this).attr('checked', false);

          });

          // Update content

          var filterURL = $( '#filters' ).attr( 'action' );

          $( '#onfilterclickupdatecontent' ).load( filterURL + ' #resulttextproductsandpagination' , function() {

            // Update URL in address bar
            history.pushState( null, null, filterURL );

          });

          gtag('event', 'click', {
            'event_category': 'Tyhjennä tuotefiltterivalinnat',
            'event_label': 'tyhjennetty',
            'value': 1
          });

        });

        $('a[href$=".pdf"]').prop('target', '_blank');

        // If referrer on single product page is product listing, then change breadcrumb link to act as browser back button.

        $( '#breadcrumbs a' ).each(function( index ) {

          var thishref = $( this ).attr( 'href');
          var thishost = window.location.hostname;

          if( thishref.indexOf( thishost + '/tuotteet' ) !== -1 || thishref.indexOf( thishost + '/en/products' ) !== -1 ) {

            if (document.referrer.indexOf(window.location.host) !== -1) {

              $( this ).attr( 'href', document.referrer );

              $( this ).click(function(e) {

                history.go(-1);
                e.preventDefault();

              });

            }

          }

        });

        // Make the back button go -1 instead of a link on single reference page if referrer is the reference list.

        if( $( 'body' ).hasClass('single-references') ) {

          //console.log('We are on single reference page.');

          var thishost = window.location.hostname;

          if (document.referrer.indexOf(window.location.host) !== -1) {

            //console.log('Referrer is same domain.');

            $( '.link-as-button a' ).click(function(e) {

              //console.log('You clicked the button!');

              history.go(-1);
              e.preventDefault();

            });

          }

        }

        wishlistToFormTextarea();

    }

    // smooth scroll
    $(function() {
        $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });

	// Tabs
	$(document).ready(function(){
		$('ul.tab_navi li').click(function(){
			var tab_id = $(this).attr('data-tab');

			$('ul.tab_navi li').removeClass('current');
			$('.tab__content').removeClass('current');

			$(this).addClass('current');
			$("#"+tab_id).addClass('current');
		});
	});

    $('.referencefilteroptions button').click(function(e){

      if( $( this ).hasClass( 'active' ) ) {

        $( '.reference' ).show();
        $( '.referencefilteroptions button' ).removeClass( 'active' );

      }
      else {

        $( '.reference' ).hide();
        $( '.referencefilteroptions button' ).removeClass( 'active' );

        var buttonname = $( this ).attr('name');

        $( this ).addClass( 'active' );
        $( '.reference.' + buttonname ).show();

        // console.log( 'You clicked on ' + buttonname );

        gtag('event', 'click', {
          'event_category': 'Referenssifiltteri',
          'event_label': buttonname,
          'value': 1
        });

      }

      e.preventDefault();

    });

    $(function(){
      var stickyHeaderTop = $('#main-navigation').offset().top;
      $(window).scroll(function(){
        if( $(window).scrollTop() > stickyHeaderTop ) {
          $('#main-navigation').addClass('fixednavigation');
        } else {
          $('#main-navigation').removeClass('fixednavigation');
        }
      });
    });

    /**
     * Procedure for updating product listing view when using filters.
     *
     * @param clickedfilter Clicked checkbox element
     */
    function updateFilteredView(clickedfilter) {
      // Display loading animation
      $(".filters_wrapper").append(
        '<div id="filter-click-loading-animation"><img src="/wp-content/themes/helaform/built-assets/images/loading.gif" alt=""></div>'
      );

      // Create an empty array for active filters
      var activeFilters = [];

      // Loop through all checked checkboxes
      $('form#filters input[type="checkbox"]').each(function (index) {
        if ($(this).is(":checked")) {
          var attributeName = $(this)[0].name;
          var attributeValue = $(this)[0].value;

          if (!activeFilters[attributeName]) {
            activeFilters[attributeName] = [];
          }

          activeFilters[attributeName].push(attributeValue);
        }
      });

      // Create empty string, where we are going to add attribute names and values for
      // WP's query
      var parameterString = "";

      // Add parameter names and values
      for (key in activeFilters) {
        if (parameterString !== "") {
          parameterString += "&";
        }
        parameterString +=
          key + "=" + encodeURIComponent(activeFilters[key].join(","));
      }

      var filterURL = $('#filters').attr('action') + '?' + parameterString;

      $("#onfilterclickupdatecontent").load(
        filterURL + " #resulttextproductsandpagination",
        function (response, status, xhr) {
          // Remove loading animation after 0,2 seconds
          setTimeout(function () {
            $("#filter-click-loading-animation").remove();
          }, 200);

          // Update URL in address bar
          history.pushState(null, null, filterURL);

          if (status == "error") {
            alert(
              "Sorry but there was an error:" +
                xhr.status +
                " " +
                xhr.statusText
            );
          } else {
            var checkbox_name = clickedfilter.attr("name");
            var checkbox_value = clickedfilter.val();

            //console.log( 'You clicked on ' + checkbox_name + ' that has value ' + checkbox_value );

            gtag("event", "click", {
              event_category: "Tuotefiltteri",
              event_label: checkbox_name + " " + checkbox_value,
              value: 1,
            });
          }
        }
      );
    }

    // Update product page content according to selected filters
    $( 'form#filters input[type=checkbox]' ).change(function() {

      var clickedfilter = $(this);
      updateFilteredView(clickedfilter);

    });

    // Add print button to Wishlist page.
    if( $('html').attr('lang') === 'fi' ) { var printbuttontext = 'Tulosta listasi'; }
    else { var printbuttontext = 'Print Your list'; }
    $( 'table.wishlist-table' ).after('<p class="action-buttons"><button type="button" onclick="window.print();" title="print"><i class="icon ion-printer"></i> '+printbuttontext+'</button></p>');


    // On Wishlist page add list of products to form textarea.

    function wishlistToFormTextarea() {

      var wishlistitems = '';

      $( 'table.wishlist-table tbody tr' ).each(function( index ) {

        //console.log('We are looping table! Row: ' + index);

        var sku = $( this ).children( '.product-sku' ).text();
        var nimi = $( this ).children( '.product-name' ).children( 'a' ).text();
        var kpl = $( this ).children( '.product-quantity' ).children( '.rl-wishlist-item-quantity' ).val();

        if( $('html').attr('lang') === 'fi' ) { var kpltxt = 'kpl'; }
        else { var kpltxt = 'pcs'; }

        //console.log( sku + ': ' + nimi + ' (' + kpl + ' '+kpltxt+')' );

        if( nimi.length > 0 ) {

          //console.log('Adding to string...');

          wishlistitems += sku.trim() + ': ' + nimi.trim() + " (" + kpl.trim() + " " + kpltxt + ")\n";

        }

      });

      if( wishlistitems.length > 0 ) {

        //console.log('Adding to textarea...');

        $( '.ginput_container_textarea textarea' ).val( wishlistitems );

        //console.log('Done.');

      }

    }

    // Hide the Save quantity button since we will fake a click for it
    $( 'table.wishlist-table tfoot' ).hide();

    $( 'table.wishlist-table .rl-wishlist-item-quantity' ).change(function() {

      wishlistToFormTextarea();

      // Fake a click on the Save quantity button
      $( '.rl-save-wishlist-button' ).click();

    });

    return {
        init: init
    };
}(jQuery));
